'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MoneyValue: {
        displayName: 'MoneyValue'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/MoneyValue/MoneyValue.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MoneyValue = _wrapComponent('MoneyValue')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(MoneyValue, _Component);

    function MoneyValue(props) {
        (0, _classCallCheck3.default)(this, MoneyValue);
        return (0, _possibleConstructorReturn3.default)(this, (MoneyValue.__proto__ || (0, _getPrototypeOf2.default)(MoneyValue)).call(this, props));
    }

    (0, _createClass3.default)(MoneyValue, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('MoneyValue');

            return _react3.default.createElement(View, this.props);
        }
    }]);
    return MoneyValue;
}(_react2.Component), _class.propTypes = {
    value: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
    icon: _react2.PropTypes.string,
    icon_after_value: _react2.PropTypes.bool,
    prefix: _react2.PropTypes.string
}, _temp));

exports.default = MoneyValue;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MoneyValue/MoneyValue.jsx
// module id = 1692
// module chunks = 0